import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApContentModule, ApContentPipe } from '@ap/content';

import { PhonenumberValidationMoreInfoModalComponent } from './phonenumber-validation-moreinfo-modal.component';

@NgModule({
    imports: [ApContentModule, CommonModule],
    exports: [],
    declarations: [PhonenumberValidationMoreInfoModalComponent],
    providers: [ApContentPipe]
})
export class PhonenumberValidationMoreinfoModalModule {}
